export default "__VITE_ASSET__BakO7eO4__"